module.exports = __webpack_public_path__ + "static/media/hr_practitioners-01.ed4ccb90.png";